<template>
  <div class="tw-w-max tw-mx-auto tw-mt-8">
    <button
      class="tw-max-w-sm tw-w-full tw-py-5 tw-flex tw-gap-x-3 tw-items-center tw-cursor-pointer hover:tw-border-b tw-border-primary hover:tw-bg-white"
      @click="thePeerFunding"
      :class="[
        index + 1 !== wallets.length
          ? 'tw-border-b tw-border-gray-light'
          : null,
      ]"
      v-for="(wallet, index) in wallets"
      :key="index"
    >
      <div
        class="tw-bg-gray-light tw-w-14 tw-h-14 tw-rounded tw-border tw-border-gray-dark tw-flex tw-items-center tw-justify-center"
      >
        <img class="tw-w-8 tw-h-8" :src="wallet.logo" :alt="wallet.name" />
      </div>
      <p class="tw-text-secondary tw-text-base">{{ wallet.name }}</p>
      <img class="tw-block tw-ml-auto" src="@/assets/img/caret-right.svg" />
    </button>
  </div>
</template>

<script setup>
  import responseHandler from "@/utils/responseHandler";
  import { getItem } from "@/utils/storage";
  import { computed, ref } from "vue";
  import { useStore } from "vuex";

  const emit = defineEmits(["close"]);

  const store = useStore();

  // const wallets = ref([
  //   {
  //     name: "Chipper Cash",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/CYIjplrB5B1QVEr9YTboZ2FfoqobDUpshTTuJeKu.png",
  //     logo_colour: "#000000",
  //   },
  //   {
  //     name: "Flip",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/ylaX0z4dfu1QTzjjSRlMnLSv3MtYKQbLyUAUatCc.jpg",
  //     logo_colour: "#000000",
  //   },
  //   {
  //     name: "Up to 15% cashback with Sendfunds",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/sfrCOaLJrDtlvB8Gsd1oeriqZFv107rcfDDjueHN.png",
  //     logo_colour: "#424153",
  //   },
  //   {
  //     name: "Pactpay",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/g56HnJL8MZfvexOYLpP2i4lyRM0PhXoaMmeR7Yy3.png",
  //     logo_colour: "#663399",
  //   },
  //   {
  //     name: "Nguvu Health",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/8qSqSbzxNEDUWdR5kBoneeNtvmXYUhN3Gu6RQPS9.png",
  //     logo_colour: "#0066FF",
  //   },
  //   {
  //     name: "Bitsika",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/lR5DCK62BI3XSO9wgvkT0OSj56r9jGSgbbbGKLZG.png",
  //     logo_colour: "#E7D8B1",
  //   },
  //   {
  //     name: "Eversend",
  //     logo: "https://palaciodepeer.s3.us-east-2.amazonaws.com/business_logos/yTN32T4qoW6sYeWWcuT8eBaxoaYmzAOIMlsMfqks.png",
  //     logo_colour: "#0066CC",
  //   },
  // ]);

  const wallets = computed(
    () => store.state.investorModule.thePeerWallets?.businesses
  );

  const currency = computed(() => store.state.investorModule.currency);

  const getWallets = async () => {
    await store.dispatch("investorModule/getThePeerWallets");
  };
  const getWalletBalance = async () => {
    await store.dispatch("investorModule/getWalletBalance");
  };
  const thePeerFunding = async () => {
    const payload = getItem("fundPayload");
    const user = getItem("org_details");
    const { amount, tokens } = payload;
    const thePeerInstance = new ThePeer.directCharge({
      publicKey: `${process.env.VUE_APP_THE_PEER}`,
      amount: amount * 100,
      currency: currency.value,
      userReference: user.thepeer_reference,
      meta: {
        tokens: tokens,
        entity: "user",
      },

      onError: function (error) {
        responseHandler.handleError(error);
      },

      onClose: () => {
        store.dispatch("showToast", {
          description: "Something happened, try again",
          display: true,
          type: "error",
        });
      },

      onSuccess: async () => {
        await getWalletBalance();
        emit("close", "Fintech Wallet");
        store.dispatch("showToast", {
          description: "Account Funded successfully",
          display: true,
          type: "success",
        });
      },
    });
    thePeerInstance.setup();
    thePeerInstance.open();
  };
  getWallets();
</script>

<style lang="scss" scoped></style>
